<template lang="pug">
#laudos
    SelecionarTerritorio(
        :tipoLaudo='tipoLaudo',
        @getTerritoriosSelecionados='solicitarLaudos',
        @cancelar-modal='changeShowModalSelecionarTerritorio',
        ref='selecionarTerritorio'
    )
</template>

<script>
import SelecionarTerritorio from '@/modules/laudos/components/SelecionarTerritorio.vue';
import TipoLaudo from '@/modules/laudos/constants/TipoLaudo';

import LaudoService from '@/modules/laudos/services/LaudosService';
import { mapState } from 'vuex';
import { connect, subscribe, disconnect } from '@/utils/websocket';

export default {
    name: 'bacenResolucao140Modal',
    components: {
        SelecionarTerritorio
    },
    computed: {
        ...mapState(['usuarioLogado', 'usuarioIsLaudo'])
    },
    data() {
        return {
            tipoLaudo: TipoLaudo.BACEN_140,
            showModalVisualizacao: false,
            showModalSelecionarTerritorios: false,
            idLaudo: null,
            laudos: [],
            pageParams: {
                page: 1,
                size: 20,
                sort: 'dataCadastro,DESC'
            },
            filtros: {
                dataCadastroFim: '',
                dataCadastroInicio: '',
                dataFinalizacaoFim: '',
                dataFinalizacaoInicio: '',
                representantesCpfCnpj: [],
                situacaoId: '',
                statusId: '',
                territoriosIds: [],
                tipoLaudoId: TipoLaudo.BACEN_140
            },
            rowInfo: null,
            totalLaudos: 0,
            usuariosBuffer: {},
            loading: false,
            isLaudoUnico: false
        };
    },
    async created() {
        if (this.usuarioIsLaudo) {
            this.$router.push({ name: 'LaudoAvaliacaoSocioambiental' });
        }
        await this.getLaudos();
    },
    async mounted() {
        await connect();

        if (this.usuarioLogado) {
            subscribe(
                `${this.usuarioLogado.idKeyCloack}/laudo/bacen/resultado`,
                response => {
                    const laudoProcessado = JSON.parse(response);
                    const laudoSelecionado = this.laudos.find(
                        p => p.id === laudoProcessado.id
                    );
                    if (laudoSelecionado) {
                        laudoSelecionado.situacao.codigo =
                            laudoProcessado.situacao.codigo;
                        laudoSelecionado.situacao.nome =
                            laudoProcessado.situacao.nome;
                        laudoSelecionado.status = {
                            codigo: laudoProcessado.status.codigo,
                            nome: laudoProcessado.status.nome
                        };
                    }
                }
            );
        } else {
            this.$notify.error({
                message: this.$t('laudos.erro.usuarioDeslogado')
            });
        }
    },
    beforeDestroy() {
        disconnect();
    },
    methods: {
        async getLaudos() {
            await this.requestLaudos();
        },

        changeShowModalSelecionarTerritorio() {
            this.showModalSelecionarTerritorios =
                !this.showModalSelecionarTerritorios;
            this.$emit('showModalSelecionarTerritorios');
        },

        solicitarLaudos(idsTerritoriosSelecionados) {
            let idsTerritorio = '';
            idsTerritoriosSelecionados.forEach(territorio => {
                idsTerritorio += territorio.id + '-';
            });
            this.$router.push({
                name: 'LaudoSolicitacaoBacenResolucao140',
                params: { idsTerritorio }
            });
        },

        async requestLaudos() {
            try {
                this.loading = true;
                const { data } = await LaudoService.requestLaudos(
                    this.filtros,
                    this.pageParams
                );
                this.totalLaudos = data.totalItens;
                this.laudos = data.laudos;
            } catch (error) {
                this.$notify.error({
                    message: this.$t(
                        'laudos.erro.naoFoiPossivelCarregarOsDados'
                    )
                });
            } finally {
                this.loading = false;
            }
        },

        handleModalLaudo(laudo) {
            this.showModalVisualizacao = !this.showModalVisualizacao;
            this.idLaudo = laudo;
        },

        handleSort(paramsProp) {
            this.pageParams = {
                page: this.pageParams.page,
                size: 20,
                sort: `${paramsProp.column},${paramsProp.order}`
            };
            this.requestLaudos();
        },

        filtrar(filtros) {
            this.filtros = { ...filtros };
            this.requestLaudos();
        },

        atualizaLaudoUnico(laudoUnico) {
            this.isLaudoUnico = laudoUnico === 'true';
        }
    }
};
</script>

<style scoped lang="scss">
#laudos {
    .laudo-margin {
        margin-bottom: 20px;
    }

    .selecionados,
    .nao-selecionados {
        display: flex;
        flex-direction: column;

        .el-checkbox {
            width: 100%;
            display: flex;
            align-items: center;

            .el-checkbox__label {
                display: flex;
                flex-direction: column;

                p {
                    line-height: 16px;
                }
            }

            em {
                font-weight: 200;
                font-size: 12px;
            }
        }
    }

    .lista {
        background: var(--white);
        border-radius: 4px;
        overflow: hidden;
    }

    header {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
}
</style>
